import { GraphQLObjectType, GraphQLString } from 'graphql';

import UserType from './user.gql';
import ReviewType from './review.gql';

const reviewsReceivedType = new GraphQLObjectType({
  name: 'ReviewsReceived',
  fields: () => ({
    // id: {
    //   type: new GraphQLNonNull(GraphQLID),
    //   resolve: (item) => item.id
    // },
    pid: {
      type: GraphQLString,
      resolve: item => item.pid
    },
    reviewedBy: {
      type: UserType,
      resolve: item => item.reviewedBy
    },
    review: {
      type: ReviewType,
      resolve: item => item.review
    }
  })
});

window[reviewsReceivedType.name + 'GQLType'] = reviewsReceivedType;

export default reviewsReceivedType;
